import * as $ from 'jquery';
import { DefaultService } from '../../common/services/DefaultService';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { EmailModel } from '../models/EmailModel';

export class CustomerEmailService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/customerEmail`;

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: EmailModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEdit = () => `${this.baseUrl}/edit`;
    public edit(model: EmailModel): JQueryPromise<any> {
        return $.ajax(this.RouteEdit(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDelete = (id: number) => `${this.baseUrl}/delete?id=${id}`;
    public delete(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(id), {
            type: 'delete',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}